<template>
  <header>
    <slot></slot>
    <a href="#slider" class="down">
      <img src="/img/arrow-down.png" alt="" />
    </a>
    <div class=" block_text">
      <div class="b-t-border"></div>
      <div class="b-b-border"></div>
      <div class="text_gallery">LEON <span> в фотографиях</span></div>
    </div>
  </header>
</template>

<style scoped>
header {
  height: 100vh;
  max-height: 100vh;
  background-image: url("/mailphotos/ARM_9712.jpg");
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: flex-start;
  align-content: space-between;
  padding-top: 30px;
}

.down {
  position: absolute;
  bottom: 25px;
  left: calc(50% - 37.175px);
}

.block_text {
  margin: auto;
  position: relative;
}
.b-t-border {
  width: 211px;
  position: absolute;
  border-top: 2px solid #d9ccaf;
  left: 0;
  right: 0;
  margin: auto;
}
.b-b-border {
  top: 190px;
  width: 211px;
  position: absolute;
  border-bottom: 2px solid #d9ccaf;
  left: 0;
  right: 0;
  margin: auto;
}
.text_gallery {
  padding: 40px 0;
  font-size: 69px;
  font-family: "playfair";
  line-height: 92px;
  color: white;
}

.text_gallery span {
  font-style: italic;
}

@media screen and (max-width: 725px) {
  .text_gallery {
    padding: 20px 0;
    font-size: 59px;
    line-height: 82px;
  }
  .b-t-border {
    width: 200px;
  }
  .b-b-border {
    top: 170px;
    width: 200px;
  }
}
@media screen and (max-width: 1200px) {
  .block_text {
    margin-top: 370px;
  }
}
@media screen and (max-width: 625px) {
  .text_gallery {
    padding: 20px 0;
    font-size: 49px;
    line-height: 72px;
  }
  .b-t-border {
    width: 190px;
  }
  .b-b-border {
    top: 140px;
    width: 190px;
  }
}

@media screen and (max-width: 525px) {
  .text_gallery {
    padding: 20px 0;
    font-size: 39px;
    line-height: 62px;
  }
  .b-t-border {
    width: 170px;
  }
  .b-b-border {
    top: 120px;
    width: 170px;
  }
}
@media screen and (max-width: 425px) {
  .text_gallery {
    padding: 20px 0;
    font-size: 29px;
    line-height: 52px;
  }
  .b-t-border {
    width: 140px;
  }
  .b-b-border {
    top: 100px;
    width: 140px;
  }
}
</style>

<style>
html {
  scroll-behavior: smooth;
}
</style>
